<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat v-if="!readonly && showRegistrai">
          <v-spacer></v-spacer>
          <el-button :disabled="!canLock" @click.native="lockNtr(true)">
            Užrakinti registrus
          </el-button>
          <el-button :disabled="!canUnlock" @click.native="lockNtr(false)">
            Atrakinti registrus
          </el-button>
        </v-toolbar>
      </template>
      <template #[`item.pas_pavadinimas`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            {{ item.pas_pavadinimas }}
          </v-col>
          <v-col cols="12" md="12" v-if="item.asmuo_pavadinimas">
            <span class="text-gray">{{ item.asmuo_pavadinimas }}</span>
          </v-col>
        </v-row>
      </template>
      <template #[`item.tur_identifikatorius`]="{ item }">
        <div class="nowrap">{{ item.tur_identifikatorius }}</div>
      </template>
      <template #[`item.pas_sukurimo_data`]="{ item }">
        <div class="nowrap">{{ item.pas_sukurimo_data }}</div>
      </template>
      <template #[`item.pas_busena`]="{ item }">
        <el-busena :busena="item.pas_busena" />
      </template>
      <template #[`item.busena`]="{ item }">
        <el-busena :busena="item.busena" :color="item.busenaColor" />
      </template>
      <template #[`body.append`]>
        <tr>
          <td :colspan="6" class="text-end">
            <strong>Iš viso:</strong>
          </td>
          <td class="text-center">{{ visoVerte }}</td>
          <td class="text-center" v-if="showVisoGrazintina">
            {{ visoGrazintina }}
          </td>
          <td :colspan="2" v-if="showRegistrai"></td>
        </tr>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import rowClass from '@/mixins/rowClass'
import userRole from '@/mixins/userRole'
import math from '@/mixins/math'

export default {
  name: 'PrasymasPaslaugos',
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    isPerduotas: { type: Boolean, default: false },
    refreshKey: String,
  },
  mixins: [rowClass, math, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      paslaugos: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      refreshTimer: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    headers() {
      return [
        {
          text: 'Prašymo numeris',
          align: 'start',
          value: 'pas_prasymas',
        },
        {
          text: 'Paslaugos pavadinimas',
          align: 'start',
          value: 'pas_pavadinimas',
        },
        {
          text: 'Registro numeris',
          align: 'start',
          value: 'tur_registras',
        },
        {
          text: 'Unikalus numeris',
          align: 'start',
          value: 'tur_identifikatorius',
        },
        {
          text: 'Data',
          align: 'start',
          value: 'pas_sukurimo_data',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pas_busena',
        },
        {
          text: 'Kaina, Eur',
          align: 'center',
          value: 'kainaFormat',
        },
        {
          text: 'Grąžintina suma, Eur',
          align: 'center',
          value: 'grazintinaFormat',
          hide: !this.showVisoGrazintina,
        },
        {
          text: 'Atsakymas iš registro',
          align: 'center',
          value: 'busena',
          hide: !this.showRegistrai,
        },
        {
          text: 'Registrą redaguojantis asmuo',
          align: 'center',
          value: 'redaguoja',
          hide: !this.showRegistrai,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paslaugos.map(item => {
        item.kainaFormat = this.moneyformat(item.pas_kaina ?? 0)
        item.grazintinaFormat = this.moneyformat(item.pas_grazintina ?? 0)
        item.pas_busena = item.pas_busena ?? 'Naujas'

        switch (item.bukle) {
          case this.bukleTvarkomas:
            item.busena = 'Tvarkomas'
            item.busenaColor = 'red'
            item.redaguoja = `${item.redaktorius}, ${item.data_redagvimo}`
            break
          case this.bukleSutvarkytas:
            if (item.statusas === this.statusRedaguoja) {
              item.redaguoja = `${item.redaktorius}, ${item.data_redagvimo}`
              if (item.programa === this.savaPrograma) {
                item.busena = 'Užrakintas'
                item.busenaColor = 'green'
              } else {
                item.busena = 'Redaguojamas'
                item.busenaColor = 'red'
              }
            } else {
              item.busena = 'Sutvarkytas'
            }
            break
          case this.buklePanaikintas:
            item.busena = 'Panaikintas'
            item.busenaColor = 'red'
            break
          default:
            item.busena = 'Nenustatytas'
            break
        }

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    savaPrograma() {
      return 'TURTAS'
    },
    statusRedaguoja() {
      return 1
    },
    bukleTvarkomas() {
      return 1
    },
    bukleSutvarkytas() {
      return 4
    },
    buklePanaikintas() {
      return 5
    },
    refreshTimeout() {
      return 10000
    },
    canLock() {
      return (
        this.itemsList.filter(item => {
          return (
            item.bukle === this.bukleSutvarkytas &&
            item.statusas !== this.statusRedaguoja
          )
        }).length > 0
      )
    },
    canUnlock() {
      return (
        this.itemsList.filter(item => {
          return (
            item.bukle === this.bukleSutvarkytas &&
            item.statusas === this.statusRedaguoja &&
            item.programa === this.savaPrograma
          )
        }).length > 0
      )
    },
    visoVerte() {
      return this.moneyformat(
        this.paslaugos
          .map(item => (item.pas_kaina > 0 ? item.pas_kaina : 0))
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          }, 0)
      )
    },
    visoGrazintina() {
      return this.moneyformat(
        this.paslaugos
          .map(item => (item.pas_grazintina > 0 ? item.pas_grazintina : 0))
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          }, 0)
      )
    },
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    busenaGalutine() {
      return (
        this.itemsList.filter(item => {
          return (
            item.pas_busena &&
            item.pas_busena !== 'Atmestas' &&
            item.pas_busena !== 'Įvykdytas' &&
            item.pas_busena !== 'Atliktas' &&
            item.pas_busena !== 'Atšauktas'
          )
        }).length === 0
      )
    },
    showVisoGrazintina() {
      return this.roleOr([
        'RG_STSR_registrat',
        'RG_NTR_registrat',
        'RG_NTR_vadovas',
      ])
    },
    showRegistrai() {
      return (
        this.isPerduotas &&
        this.roleOr(['RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'])
      )
    },
  },
  watch: {
    refreshKey() {
      this.getData()
    },
  },
  beforeDestroy() {
    this.stopRefreshing()
  },
  created() {
    this.pageloading = true
    this.getData()
  },
  methods: {
    getData() {
      this.loading = this.pageloading
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/paslaugos`)
        .then(res => {
          this.paslaugos = res.data.paslaugos
          this.checkRefresh()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    updatePaslaugosList() {
      this.getData()
    },
    checkRefresh() {
      if (!this.isLocal && !(this.isIregistruotas || this.busenaGalutine)) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            this.getData()
          }, this.refreshTimeout)
        }
      } else {
        this.stopRefreshing()
      }
    },
    stopRefreshing() {
      clearInterval(this.refreshTimer)
    },
    lockNtr(lock) {
      this.loading = true
      const data = {
        redaguojamas: lock,
      }
      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/ntr-registras-keisti`,
          data
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.duomenys {
  padding-top: 10px;
  padding-bottom: 10px;

  p {
    padding: 3px 0px;
    margin: 0;
  }

  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 30%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
